module.exports = "/assets/ae0cf9d092461762565c30dccc2437df.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/WX.png
// module id = 1976
// module chunks = 0